import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'redux-first-router-link';

export const CuiLink = ({ children, className, href, to, ...rest }) => {
  const classes = classNames('cuiLink', className);

  if (href) {
    return (
      <a className={classes} href={href} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <Link className={classes} to={to} {...rest}>
      {children}
    </Link>
  );
};

CuiLink.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  to: PropTypes.object,
};

CuiLink.defaultProps = {
  children: undefined,
  className: undefined,
  href: undefined,
  to: undefined,
};



// WEBPACK FOOTER //
// ./ui/components/link/Link.js